<template>
  <section id="reach-badge" :class="getClassNames()">
    <div class="withReach__wrapper">
      <svg
        width="36"
        height="44"
        viewBox="0 0 36 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2832_76872)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.0833 36.9702V43.4046H12.2948V41.022H13.3672L14.5501 43.4046H15.8872L14.5889 40.9188C15.4117 40.6718 15.9639 39.9695 15.9639 38.9966C15.9639 37.7732 15.1208 36.9702 13.9093 36.9702H11.0833ZM16.7328 36.9626V43.4046H17.9444V36.9626H16.7328ZM23.8173 36.9626V43.4046H25.0289V36.9626H23.8173ZM31.1581 36.9626V43.4037H33.3594C35.0844 43.4037 36 42.55 36 40.7894V39.5744C36 37.8188 35.0844 36.9626 33.3594 36.9626H31.1581ZM0 36.9609L1.78735 43.4029H3.67419L5.46407 36.9609H4.21967L2.78726 42.3267H2.67681L1.24693 36.9609H0ZM6.02052 36.9609V43.4029H10.2916V42.2988H7.23119V40.7115H9.98304V39.6015H7.23119V38.0634H10.2402V36.9609H6.02052ZM19.0092 36.9609V43.4029H20.2207V40.7268H22.9177V39.6193H20.2207V38.0659H23.1007V36.9609H19.0092ZM26.0928 36.9609V43.4029H30.3665V42.2988H27.3044V40.709H30.0554V39.6015H27.3044V38.0659H30.3125V36.9609H26.0928ZM34.7885 39.5406V40.8283C34.7885 41.7649 34.4133 42.2996 33.3797 42.2996H32.3688V38.0642H33.3797C34.4133 38.0642 34.7885 38.5981 34.7885 39.5406ZM14.7533 38.9966C14.7533 39.5567 14.3671 39.9154 13.7888 39.9154H12.2948V38.0752H13.7888C14.3671 38.0752 14.7533 38.4339 14.7533 38.9966ZM28.8843 25.2709V34.5513H31.0055V30.6366C31.0055 30.0714 31.1649 29.6425 31.481 29.3489C31.7972 29.057 32.1656 28.9098 32.5897 28.9098C33.448 28.9098 33.8779 29.4674 33.8779 30.585V34.5513H35.9992V30.1383C35.9992 29.2381 35.7268 28.5172 35.1788 27.9783C34.6308 27.4385 33.9597 27.1703 33.1655 27.1703C32.3654 27.1703 31.648 27.48 31.0055 28.1018V25.2709H28.8843ZM22.7854 28.381C22.0991 29.0494 21.7518 29.9166 21.7518 30.9776C21.7518 32.0428 22.094 32.9024 22.7727 33.5631C23.454 34.2214 24.2895 34.5513 25.2776 34.5513C26.2648 34.5513 27.183 34.0869 28.0311 33.1553L26.9435 31.8651C26.452 32.5106 25.8998 32.833 25.2902 32.833C24.8248 32.833 24.4185 32.6706 24.0711 32.3423C23.7263 32.0174 23.5518 31.558 23.5518 30.9666C23.5518 30.376 23.7263 29.9166 24.0711 29.5833C24.4185 29.2508 24.8324 29.0883 25.3155 29.0883C25.6165 29.0883 25.92 29.1602 26.226 29.3075C26.5321 29.4521 26.7918 29.6611 27.0025 29.9268L27.9569 28.6078C27.5919 28.2025 27.1644 27.8979 26.6788 27.6915C26.1948 27.485 25.7143 27.3818 25.2388 27.3818C24.292 27.3818 23.4776 27.7152 22.7854 28.381ZM8.90136 28.3489C8.26904 28.9969 7.95288 29.8667 7.95288 30.9607C7.95288 32.0555 8.26398 32.9252 8.88618 33.575C9.50585 34.2256 10.2874 34.5505 11.2393 34.5505C12.1903 34.5505 13.0156 34.1816 13.7205 33.4413L12.7433 32.267C12.3496 32.7213 11.8454 32.9481 11.2342 32.9481C10.8531 32.9481 10.5108 32.8296 10.2107 32.5893C9.90717 32.3465 9.72927 32.0369 9.67532 31.6578H14.2348V30.6256C14.2348 29.6163 13.9312 28.8243 13.3318 28.2456C12.7332 27.6678 11.9997 27.381 11.1389 27.381C10.2798 27.381 9.53115 27.7042 8.90136 28.3489ZM15.335 28.3776L16.1452 29.629C16.3846 29.4301 16.6797 29.2677 17.0296 29.1306C17.3795 28.9995 17.7108 28.9318 18.0253 28.9318C18.7554 28.9318 19.123 29.3015 19.123 30.0418V30.0808H17.7707C16.9343 30.0808 16.2767 30.2559 15.7928 30.6095C15.3097 30.9657 15.0703 31.4945 15.0703 32.2069C15.0703 32.9168 15.3046 33.4845 15.77 33.9109C16.2354 34.3365 16.8112 34.5505 17.5 34.5505C18.1897 34.5505 18.763 34.2358 19.2309 33.6088V34.4473H20.9306V30.019C20.9306 29.1052 20.681 28.4343 20.1828 28.013C19.6862 27.5925 19.0429 27.381 18.2538 27.381C17.1611 27.381 16.1865 27.7118 15.335 28.3776ZM0 24.8512V34.1317H2.03101V31.1688H3.43813L5.45396 34.1317H7.95372L5.64956 30.8101C6.80628 30.3769 7.37958 29.4166 7.37958 27.9301C7.37958 26.8488 7.07944 26.067 6.47747 25.5788C5.87297 25.0941 4.86548 24.8512 3.45077 24.8512H0ZM19.1103 31.7991C19.1103 32.1528 18.9864 32.4345 18.7394 32.646C18.4983 32.8575 18.2125 32.9633 17.8912 32.9633C17.57 32.9633 17.323 32.8965 17.151 32.7619C16.9782 32.6283 16.8913 32.437 16.8913 32.1866C16.8913 31.7043 17.2513 31.4641 17.9764 31.4641H19.1103V31.7991ZM12.0461 29.3193C12.2881 29.5443 12.4272 29.8616 12.4651 30.2745H9.72169C9.76806 29.8794 9.93499 29.5647 10.2208 29.3328C10.5083 29.1002 10.8228 28.9843 11.1693 28.9843C11.5141 28.9843 11.8075 29.0951 12.0461 29.3193ZM4.92197 26.908C5.18164 27.0941 5.30979 27.4377 5.30979 27.9377C5.30979 28.4385 5.1867 28.8024 4.93461 29.0325C4.68253 29.2618 4.20955 29.3777 3.51485 29.3777H2.03101V26.6297H3.55363C4.20703 26.6297 4.66229 26.7227 4.92197 26.908ZM8.7926 24.8504V26.1153H27.6281V24.8504H8.7926ZM8.55063 10.0807C8.55063 15.3102 12.7905 19.5659 18.0025 19.5659C23.2103 19.5659 27.4527 15.3102 27.4527 10.0807C27.4527 8.31323 26.9646 6.59149 26.0439 5.09988C25.8762 4.82407 25.5887 4.64301 25.27 4.60409C24.9479 4.57109 24.6267 4.67939 24.4007 4.90867L17.468 11.8718L14.4649 8.85725C14.0535 8.44183 13.3849 8.44183 12.9735 8.85725C12.5621 9.27098 12.5621 9.94191 12.9735 10.3548L16.7219 14.1172C17.1333 14.5301 17.8019 14.5301 18.2133 14.1172L24.8585 7.44856C25.1772 8.28193 25.3416 9.17283 25.3416 10.0807C25.3416 14.1435 22.0502 17.4465 18.0025 17.4465C13.9557 17.4465 10.6617 14.1435 10.6617 10.0807C10.6617 6.01871 13.9557 2.71229 18.0025 2.71229C19.4661 2.71229 20.8825 3.14632 22.0941 3.96447C22.5746 4.28682 23.2331 4.16329 23.5568 3.67765C23.8839 3.19032 23.7549 2.53208 23.2718 2.20381C21.7104 1.14877 19.8877 0.59375 18.0025 0.59375C12.7905 0.59375 8.55063 4.84945 8.55063 10.0807Z"
            fill="#AAAAAA"
          />
        </g>
        <defs>
          <clipPath id="clip0_2832_76872">
            <rect width="36" height="42.8108" fill="white" transform="translate(0 0.59375)" />
          </clipPath>
        </defs>
      </svg>
      <div class="withReach__seperator"></div>
      <article class="withReach__text" v-html="this.text && this.text"></article>
    </div>
  </section>
</template>
<script>
import axios from 'axios'

export default {
  props: {
    type: String,
    environment: String,
    onlyDirectLocal: Boolean,
    onlyDirectGlobal: Boolean
  },

  data() {
    return {
      generalSettings: {
        brand_name: 'Your Brand Name' // Provide the actual brand name here
      },
      text: '' // Declare text here
    }
  },

  computed: {
    brandName() {
      return this.generalSettings.brand_name
    }
  },

  methods: {
    getClassNames() {
      if (this.environment === 'global') {
        return 'withReach withReach--global'
      } else {
        return `withReach ${
          this.type === 'accordion' ? 'withReach--accordion' : 'withReach--classic'
        }`
      }
    },
    fetchData() {
      const merchantId = window.general_settings.merchant_id
      const reachBase = `https://checkout.rch.io/v2.22/badge?MerchantId=${merchantId}&Locale=${window?.countryCode?.toUpperCase()}`
      if (merchantId) {
        axios
          .get(reachBase)
          .then((response) => {
            const data = response.data
            this.text = this.modifyHtml(data.Html)
            setTimeout(() => {
              registerLinks()
            }, 500)
            if (data.result === 'ERROR') {
              console.log(data.message)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    modifyHtml(htmlString) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(htmlString, 'text/html')
      const links = doc.querySelectorAll('.reach--inline-link')
      links.forEach((link) => {
        link.setAttribute('href', '/legal/reach')
      })
      return (this.modifiedHtml = doc.body.innerHTML)
    }
  },

  mounted() {
    if (typeof this.fetchData === 'function') {
      this.fetchData()
    } else {
      console.error('fetchData is not a function')
    }
  }
}
</script>

<style scoped>
.withReach {
  border-radius: 4px;
  border: 1px solid var(--cc-shopify-border-dividers, #e0e0e0);
  background-color: #fff;
}
.withReach--global {
  background-color: transparent;
  margin-bottom: 12px;
}
.withReach--accordion {
  /* margin-top: 16px; */
}
.withReach--classic {
  /* margin-top: 16px; */
}
.withReach__wrapper {
  padding: 12px 16px;
  display: flex;
  align-items: center;
}
.withReach__seperator {
  width: 1px;
  align-self: stretch;
  background-color: #e0e0e0;
  margin: 0 16px;
}
.withReach__wrapper > svg {
  width: 36px;
  flex-shrink: 0;
  height: auto;
}

.withReach__text {
  color: var(--CC-Shopify-Ligth-gray, #828282);
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.with-reach-container {
  margin-top: 16px;
}
.reach--inline-link {
  color: #828282;
  text-decoration: underline;
}
.reach--inline-link:hover {
  color: #333;
}
</style>

<style>
.withReach__text > a {
  text-decoration: underline;
  cursor: pointer;
  transition: color 150ms ease-in;
  color: #828282 !important;
}
.reach--logo {
  display: none;
}

.reach--inline-link {
  color: #828282;
  text-decoration: underline;
}
.reach--inline-link:hover {
  color: #333;
}
</style>
